module.exports = __webpack_public_path__ + "img/Group 1.46c98c7c.png";